import { Component, OnInit, ViewChild } from '@angular/core';
import { TestResultsDataForm } from '../../_models/test-results-data-form';
import { QuestionAnswer } from '../../_models/question-answer';
import { UserSessionDataForm } from '../../_models/login/user-session-data-form';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { SpinnerService } from '../../_core/spinner/spinner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionAnswerService } from '../../_services/question-answer.service';
import { TestResultsService } from '../../_services/test-results.service';
import { MatRadioChange } from '@angular/material';
import { ValidationErrorMessageEnum } from '../../constants/ValidationErrorMessageEnum';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { MatStepperModule} from '@angular/material';
import { NavbarComponent } from '../../navbar/navbar.component';
import { NavbarService } from '../../_services/navbar.service';
import { SuccessDialogQuizComponent } from '../../success-dialog-quiz/success-dialog-quiz.component';
import { SuccessDialogQuizService } from '../../_services/success-dialog-quiz.service';


@Component({
  selector: 'app-test-search',
  templateUrl: './test-search.component.html',
  styleUrls: ['./test-search.component.css']
})
export class TestSearchComponent implements OnInit {

  @ViewChild('stepper') stepper;
  patentSearchQuestionList: QuestionAnswer[] = [];
  questionAnswer: QuestionAnswer = new QuestionAnswer();
  userSessionDataForm: UserSessionDataForm = new UserSessionDataForm();
  userTestPatentSearchFormGroup: FormGroup;
  userTestDataForm: QuestionAnswer = new QuestionAnswer();
  finalScore = 0;
  questionAnswerArray;
  hideAnswer = false;
  hideScore = false;
  selectedOption: string;
  


  constructor(
    private authService: AuthService,
    public  spinnerService: SpinnerService,
    private snotifyService: SnotifyService,
    private formbuilder: FormBuilder,
    private router: Router,
    private questionAnswerService: QuestionAnswerService,
    private activatedRoute: ActivatedRoute,
    private testResultsService: TestResultsService,
    private navbarService : NavbarService,
    private successDialogService:SuccessDialogQuizService,
  ) {
  }

  ngOnInit() {
    
    this.getPatentSearchQuestionAnswer();
    this.userTestValidation();
    this.displayAnswerOnSelected();
    
  }

  
  userTestValidation() {
  
    this.userTestPatentSearchFormGroup = this.formbuilder.group({
      'questionAnswers': new FormControl('', [
        //  Validators.compose([
        //  Validators.required])
      ]),
    });
  }


  getPatentSearchQuestionAnswer() {
    this.questionAnswerService.getPatentSearch().subscribe(
      resp => {
        this.patentSearchQuestionList = resp as QuestionAnswer[];
        const answerForLocal :any[] = [];
        this.patentSearchQuestionList.forEach(answer => {
        answerForLocal.push(answer.answer);
      localStorage.setItem('currentOption', JSON.stringify(answerForLocal));
       });

      const currentOption = localStorage.getItem('currentOption');
       this.questionAnswerArray = JSON.parse(currentOption);
      }, error => {
        console.log(error);
      });
  }

  optionOne(event: MatRadioChange) {
    let optionOneSelected = event.value;
    var score = this.patentSearchQuestionList.filter(item => item.answer === optionOneSelected);
    if (score.length > 0) {
      this.finalScore = this.finalScore + 1;
    }


  }
  optionTwo(event: MatRadioChange) {
    let optionTwoSelected = event.value;
    var score = this.patentSearchQuestionList.filter(item => item.answer === optionTwoSelected);
    if (score.length > 0) {
      this.finalScore = this.finalScore + 1;
    }
  }
  optionThree(event: MatRadioChange) {
    let optionThreeSelected = event.value;
    var score = this.patentSearchQuestionList.filter(item => item.answer === optionThreeSelected);
    if (score.length > 0) {
      this.finalScore = this.finalScore + 1;
    }
  }
  optionFour(event: MatRadioChange) {
    let optionFourSelected = event.value;
    var score = this.patentSearchQuestionList.filter(item => item.answer === optionFourSelected);
    if (score.length > 0) {
      this.finalScore = this.finalScore + 1;
    }
  }


 
  getErrorMsgForUserDetasilsFormTest() {
    return this.userTestPatentSearchFormGroup.controls.questionAnswers.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getTestScore()
  {
    
    if ( this.userTestPatentSearchFormGroup.valid) {

      let testResultsDataForm: TestResultsDataForm = new TestResultsDataForm();
      testResultsDataForm.testType = 2;
      testResultsDataForm.score = this.finalScore;
      const currentUser = localStorage.getItem('currentUser');
      testResultsDataForm.userSessionDataForm = JSON.parse(currentUser);
      this.testResultsService.saveUserTestResuts(testResultsDataForm).subscribe(
        resp => {
         
          let userData = JSON.stringify(resp);
        
           //this.hideScore = true;
          
          //   this.snotifyService.info("Your test score : "  + this.finalScore + "/" + this.patentSearchQuestionList.length, {
          //   position: SnotifyPosition.rightCenter,
          //   timeout: 0,
          //   showProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   buttons: [
          //     // {text: 'Retake', action:() =>{ this.userTestPatentSearchFormGroup.reset();
          //     //   this.stepper.selectedIndex = 0;  this.getTestScore();} , bold: true },
          //     {text: 'Proceed', action:() => { this.moveToPatentDraft();} , bold: true },
          //   ],

          // });

        }, error => {
          console.log(error);
          this.snotifyService.error(error);
        })
    } else {
      this.userTestPatentSearchFormGroup.markAsTouched();
      for (let inner in this.userTestPatentSearchFormGroup.controls) {
        this.userTestPatentSearchFormGroup.get(inner).markAsTouched();
        this.userTestPatentSearchFormGroup.get(inner).updateValueAndValidity();
      }
    }
  }

  successDialogTestSearch(){
    this.getTestScore();
    this.successDialogService.successDialogForQuiz(2,this.finalScore);
    this.navbarService.saveActiveNavItem('Patent Drafting')
  }
  
  displayAnswerOnSelected() {
    this.finalScore = 0;
    if (this.userTestPatentSearchFormGroup.valid) {
      this.hideAnswer = true;
    } else {
      this.userTestPatentSearchFormGroup.markAsTouched();
      for (let inner in this.userTestPatentSearchFormGroup.controls) {
        this.userTestPatentSearchFormGroup.get(inner).markAsTouched();
        this.userTestPatentSearchFormGroup.get(inner).updateValueAndValidity();
      }
    }
  }

}

